import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Alert, Button, Save01 } from '@opendate-app/setlist';
import { toastError, toastSuccess } from '../../../shared/toastHelper';
import { alsoTakenSummary } from './SeatsInTheWayPanel';

const plural = (count, one, many) => `${count} ${count === 1 ? one : many}`;

const SeatsInTheWayBanner = ({ seatingChart, onMoveFans, onOpenMap, onSaved }) => {
  const [report, setReport] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    let active = true;
    axios.get(`/seating_charts/${seatingChart.id}/seats_in_the_way_report`)
      .then(({ data }) => { if (active) setReport(data.seats_in_the_way); })
      .catch(() => {});
    return () => { active = false; };
  }, [seatingChart.id]);

  if (!report) return null;

  const sold = report.sold.length;
  const others = report.held.length + report.killed.length + report.carts.length + (report.taken || []).length + (report.shrunk || []).length + (report.releasing || []).length;

  const save = async () => {
    setSaving(true);
    try {
      await axios.patch(`/seating_charts/${seatingChart.id}/sync`);
      toastSuccess('Seat map saved.');
      onSaved();
    } catch (err) {
      const inTheWay = err?.response?.data?.seats_in_the_way;
      if (inTheWay) setReport(inTheWay);
      else toastError((err?.response?.data?.errors || ['The seat map could not be saved.']).join(' '));
    }
    setSaving(false);
  };

  if (sold + others === 0) {
    return (
      <Alert
        color="success"
        title="Everyone's off the seats you removed"
        description="Save the seat map to finish. Those seats come off the map and the section's capacity drops to match."
        actions={(
          <>
            <Button variant="primary" size="sm" icon={Save01} disabled={saving} onClick={save}>Save seat map</Button>
            <Button variant="secondary" size="sm" onClick={onOpenMap}>Open seat map</Button>
          </>
        )}
      />
    );
  }

  return (
    <Alert
      color="warning"
      role="alert"
      title="Your seat map changes aren't saved yet"
      description={`${sold ? `${plural(sold, 'ticket is', 'tickets are')} still on seats you removed` : 'A few seats you removed are still taken'}${sold && others ? `, plus ${alsoTakenSummary(report)}` : ''}.${report.removedOffSale ? ' Those seats stay off sale until you finish.' : ''}`}
      actions={(
        <>
          <Button variant="primary" size="sm" onClick={onMoveFans}>Move fans</Button>
          <Button variant="secondary" size="sm" onClick={onOpenMap}>Open seat map</Button>
        </>
      )}
    />
  );
};

SeatsInTheWayBanner.propTypes = {
  seatingChart: PropTypes.shape({ id: PropTypes.number.isRequired }).isRequired,
  onMoveFans: PropTypes.func.isRequired,
  onOpenMap: PropTypes.func.isRequired,
  onSaved: PropTypes.func.isRequired,
};

export default SeatsInTheWayBanner;
